import React, { Component } from 'react';
import { Row, Col, Input, Modal } from 'antd';

const { TextArea } = Input;

class EditCompay extends Component {

    constructor( props ){

        super( props );

        this.state = {
            visible     : false,
            name        : 'none',
            address     : '',
            phone       : '',
            email       : '',
            website     : '',
            id          : ''
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );

    }

    handleOk = (e) => {
        
        if( this.state.name === "" || this.state.name === "none" ){
            this.setState({
                name: ''
            });
            return false;
        }

        this.props.onSubmit( this.state );

        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.data.length !== 0 ){

            this.setState({
                visible: nextProps.onModel,
                id: nextProps.data.company_id,
                name: nextProps.data.company_name,
                address: nextProps.data.company_addres,
                phone: nextProps.data.phone,
                email: nextProps.data.email,
                website: nextProps.data.website
            })
        }

    }

    render() {
        return (
            <Modal
                maskClosable={ false }
                title="Edit Company"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.name === '') ? 'error': '' }>Company Name</label>
                        <Input 
                            value={ this.state.name }
                            className={ ( this.state.name === '') ? 'br_error': '' } onChange={ (e)=> this.setState({ name: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Company Address</label>
                        <TextArea 
                            value={ this.state.address }
                            onChange={ (e)=> this.setState({ address: e.target.value }) } rows={4} />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Phone</label>
                        <Input className={ ( this.state.name === '') ? 'br_error': '' } 
                            value={ this.state.phone }
                            onChange={ (e)=> this.setState({ phone: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Email</label>
                        <Input className={ ( this.state.name === '') ? 'br_error': '' } 
                            value={ this.state.email }
                            onChange={ (e)=> this.setState({ email: e.target.value }) } size="default"  />
                    </Col>
                </Row>
                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label>Website</label>
                        <Input className={ ( this.state.name === '') ? 'br_error': '' } 
                            value={ this.state.website }
                            onChange={ (e)=> this.setState({ website: e.target.value }) } size="default"  />
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default EditCompay


                    
                


// WEBPACK FOOTER //
// ./src/pages/company/childs/edit.company.js